import type { VariantProps } from "@gluestack-ui/utils/nativewind-utils";
import React from "react";
import { listItemStyle, listStyle } from "./styles";

type IListProps = React.ComponentPropsWithoutRef<"ul"> &
  VariantProps<typeof listStyle>;

const List = React.forwardRef<HTMLUListElement, IListProps>(
  ({ className, space, position = "outside", children, ...props }, ref) => {
    return (
      <ul
        className={listStyle({
          space,
          position,
          class: className,
        })}
        {...props}
        ref={ref}
      >
        {children}
      </ul>
    );
  },
);

List.displayName = "List";

export { List };

type IListItemProps = React.ComponentPropsWithoutRef<"li"> &
  VariantProps<typeof listItemStyle>;

const ListItem = React.forwardRef<HTMLLIElement, IListItemProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <li
        className={listItemStyle({
          class: className,
        })}
        {...props}
        ref={ref}
      >
        {children}
      </li>
    );
  },
);

ListItem.displayName = "ListItem";

export { ListItem };
